<template>
    <component
      :is="`${sticker.type}Sticker`"
      v-bind="{ ...sticker, ...sticker.data }"
      :isEditing="!previewEnabled && sticker.isEditing"
      :isPreventCover="!previewEnabled && isPreventCover"
      :isCover="!previewEnabled && isCover"
      :setCover="setCover"
      :setCbClick="setCbClick"
      :files="files"
      :backgroundFileId="backgroundFileId"
      :pageSelected="pageSelected"
      @updateSticker="updateSticker"
      @deleteSticker="deleteSticker"
    />
  </template>

  <script>

  import mentionSticker from './mention.vue';
  import linkSticker from './linkFacebook.vue';
  import textSticker from './textFacebook.vue';
  import musicSticker from './musicFacebook.vue';

  export default {
    components: {
        mentionSticker,
        linkSticker,
        textSticker,
        musicSticker,
    },
    props: {
      sticker: {
        type: Object,
        required: true
      },
      isPreventCover: {
        type: Boolean,
        required: false
      },
      isCover: {
        type: Boolean,
        required: false
      },
      setCover: Function,
      setCbClick: Function,
      files: Object,
      pageSelected: Object,
      previewEnabled: Boolean,
      backgroundFileId: String,
    },

    mounted () {
        if (this.sticker.isEditing && !this.isCover && !this.isPreventCover && !this.previewEnabled) {
            this.setCover(true)
        }
    },

    methods: {
      updateSticker(id,payload) {
        this.$emit('updateSticker', id, payload);
      },
      deleteSticker(id) {
        this.$emit('deleteSticker', id);
      }
    },
  };
  </script>
